import React, { useState } from "react";
import { toast } from "../ui/sonner";
import { AssigneeOptions } from "./AssigneeOptions";

/** 协办交接铃铛内「一键改派 N 项」：选接手人 → 该协办名下本项目全部未完成任务一次改派 */
export const HandoverReassignInline = ({ r, api, zh, onDone }) => {
  const [open, setOpen] = useState(false);
  const [opts, setOpts] = useState(null);
  const [to, setTo] = useState("");
  const [busy, setBusy] = useState(false);
  const meta = r.meta || {};
  const n = (meta.tasks || []).length;
  const stop = (e) => e.stopPropagation();
  if (meta.reassignedTo) {
    return <p className="mt-2 inline-flex items-center gap-1 text-[11px] text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-2.5 py-1" data-testid={`handover-reassigned-${r.id}`} onClick={stop}>
      ✓ {zh ? `已改派给 ${meta.reassignedTo} · ${meta.movedCount ?? n} 项` : `Reassigned to ${meta.reassignedTo} · ${meta.movedCount ?? n} tasks`}</p>;
  }
  if (!n || !r.projectId) return null;
  const openPicker = async (e) => {
    stop(e);
    setOpen(true);
    if (!opts) {
      try { const { data } = await api.get(`/projects/${r.projectId}/engine/assignees`); setOpts(data); }
      catch (err) { toast.error(err?.response?.data?.detail || (zh ? "加载同事名单失败" : "Failed to load staff")); setOpen(false); }
    }
  };
  const confirm = async (e) => {
    stop(e);
    if (!to) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/projects/${r.projectId}/engine/tasks/handover-reassign`, { reminderId: r.id, username: to });
      toast.success(zh ? `已将 ${data.moved} 项任务改派给 ${data.to}${data.kind === "co" ? "（协办）" : ""}，并已通知本人` : `${data.moved} tasks reassigned to ${data.to}`);
      setOpen(false);
      onDone && onDone();
    } catch (err) { toast.error(err?.response?.data?.detail || (zh ? "改派失败" : "Reassign failed")); }
    setBusy(false);
  };
  return (
    <div className="mt-2" onClick={stop} data-testid={`handover-reassign-${r.id}`}>
      {!open ? (
        <button type="button" data-testid={`handover-reassign-btn-${r.id}`} onClick={openPicker}
          className="inline-flex items-center gap-1 text-[11px] text-white bg-violet-600 hover:bg-violet-700 rounded-lg px-2.5 py-1">
          {zh ? `一键改派 ${n} 项` : `Reassign all ${n}`}
        </button>
      ) : (
        <div className="flex flex-wrap items-center gap-2">
          <select data-testid={`handover-reassign-select-${r.id}`} value={to} onChange={(e) => setTo(e.target.value)} disabled={!opts}
            className="text-[11px] rounded-lg border border-violet-200 px-2 py-1 bg-white max-w-[260px]">
            <option value="">{opts ? (zh ? "— 选择接手人 —" : "— Pick a colleague —") : (zh ? "加载中…" : "Loading…")}</option>
            {opts && <AssigneeOptions projectStaff={(opts.projectStaff || []).filter((s) => s.name !== meta.removed)} staff={(opts.staff || []).filter((s) => s.name !== meta.removed)} zh={zh} />}
          </select>
          <button type="button" data-testid={`handover-reassign-confirm-${r.id}`} disabled={!to || busy} onClick={confirm}
            className="text-[11px] text-white bg-violet-600 hover:bg-violet-700 disabled:opacity-40 rounded-lg px-2.5 py-1">
            {busy ? (zh ? "改派中…" : "Working…") : (zh ? `确认改派 ${n} 项` : `Confirm ${n}`)}
          </button>
          <button type="button" data-testid={`handover-reassign-cancel-${r.id}`} onClick={(e) => { stop(e); setOpen(false); }} className="text-[11px] text-slate-500 hover:text-slate-800 px-1">{zh ? "取消" : "Cancel"}</button>
        </div>
      )}
    </div>
  );
};
